import { combineReducers } from 'redux'
import { reducer as cmsBlock } from './cmsBlock'
import { reducer as instagramFeed } from './instagramFeed'

export const reducer = combineReducers({
  cmsBlock,
  instagramFeed
})
